import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const EditIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M20.5078 5.18422L15.8163 0.491714C15.6603 0.335669 15.4751 0.211885 15.2713 0.127432C15.0674 0.0429794 14.8489 -0.000488281 14.6283 -0.000488281C14.4076 -0.000488281 14.1891 0.0429794 13.9852 0.127432C13.7814 0.211885 13.5962 0.335669 13.4402 0.491714L0.492464 13.4405C0.335781 13.5959 0.211558 13.7809 0.127017 13.9848C0.042476 14.1887 -0.000696619 14.4073 8.4998e-06 14.628V19.3205C8.4998e-06 19.7661 0.17701 20.1934 0.492075 20.5085C0.80714 20.8236 1.23446 21.0006 1.68003 21.0006H6.37253C6.59324 21.0013 6.81188 20.9581 7.01575 20.8735C7.21962 20.789 7.40466 20.6648 7.5601 20.5081L20.5078 7.5604C20.6638 7.40439 20.7876 7.21917 20.8721 7.01531C20.9565 6.81146 21 6.59296 21 6.37231C21 6.15165 20.9565 5.93316 20.8721 5.7293C20.7876 5.52545 20.6638 5.34023 20.5078 5.18422ZM6.37253 19.3205H1.68003V14.628L10.9201 5.38792L15.6126 10.0804L6.37253 19.3205ZM16.8002 8.89181L12.1077 4.20036L14.6277 1.68033L19.3202 6.37178L16.8002 8.89181Z"
      fill=""
    />
  </SvgIcon>
);
